let apiURL = process.env.VUE_APP_API_URL
const ENV = process.env.NODE_ENV

// console.log(ENV);

// if (ENV === 'production') {
// apiURL = process.env.VUE_APP_API_URL_PROD
// }

const config = function (cook) {
  return {
    baseURL: "https://app.fastenergy.world/api/",
    // baseURL: "http://localhost:8000/api/",
    headers: {
      Accept: 'application/json',
      // Token: `${cook}`
    },
  };
};

export default config;
